











































































import {defineComponent} from '@vue/composition-api';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';

export default defineComponent({
  name: 'Chem2OA3_LabPerformanceTask',
  mixins: [DynamicQuestionMixin()],
  components: {StembleLatex},
});
